var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg50KNutzer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.441,
    height: 145.148,
    viewBox: "0 0 155.441 145.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36141",
    "data-name": "Gruppe 36141",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4141",
    "data-name": "Gruppe 4141",
    transform: "translate(18.082 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4139",
    "data-name": "Gruppe 4139",
    transform: "translate(12.216 121.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15400",
    "data-name": "Pfad 15400",
    d: "M1992.891,2053.657l-44.6,17.586v6.532l44.6-17.586,44.6,17.586v-6.532Z",
    transform: "translate(-1948.295 -2053.657)",
    fill: "#d2dad7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4140",
    "data-name": "Gruppe 4140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15401",
    "data-name": "Pfad 15401",
    d: "M2046.736,2065.275a1.761,1.761,0,0,1-.649-.123l-54.394-21.451-54.393,21.451a1.769,1.769,0,0,1-2.418-1.646V1922.54a1.769,1.769,0,0,1,1.769-1.769h110.085a1.769,1.769,0,0,1,1.769,1.769v140.966a1.767,1.767,0,0,1-1.769,1.769Zm-55.043-25.243a1.775,1.775,0,0,1,.649.123l52.625,20.754v-136.6H1938.419v136.6l52.625-20.754A1.772,1.772,0,0,1,1991.693,2040.032Z",
    transform: "translate(-1934.882 -1920.771)",
    fill: "#d2dad7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4189",
    "data-name": "Gruppe 4189",
    transform: "translate(21.519 7.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4183",
    "data-name": "Gruppe 4183",
    transform: "translate(0 1.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4162",
    "data-name": "Gruppe 4162",
    transform: "translate(4.547 51.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4142",
    "data-name": "Gruppe 4142",
    transform: "translate(0 52.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15402",
    "data-name": "Pfad 15402",
    d: "M1943.648,2044.869v2.812h47.776l1.053-.415,1.053.415H2041.3v-2.812Z",
    transform: "translate(-1943.648 -2044.869)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4143",
    "data-name": "Gruppe 4143",
    transform: "translate(54.885 57.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15403",
    "data-name": "Pfad 15403",
    d: "M2003.909,2050.123l7.13,2.812h35.642v-2.812Z",
    transform: "translate(-2003.909 -2050.123)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4144",
    "data-name": "Gruppe 4144",
    transform: "translate(0 33.494)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1784",
    "data-name": "Rechteck 1784",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4145",
    "data-name": "Gruppe 4145",
    transform: "translate(67.018 62.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15404",
    "data-name": "Pfad 15404",
    d: "M2017.231,2055.376l7.129,2.812h23.509v-2.812Z",
    transform: "translate(-2017.231 -2055.376)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4146",
    "data-name": "Gruppe 4146",
    transform: "translate(0 38.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1785",
    "data-name": "Rechteck 1785",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4147",
    "data-name": "Gruppe 4147",
    transform: "translate(0 43.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1786",
    "data-name": "Rechteck 1786",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4148",
    "data-name": "Gruppe 4148",
    transform: "translate(0 47.849)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1787",
    "data-name": "Rechteck 1787",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4149",
    "data-name": "Gruppe 4149",
    transform: "translate(0 62.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15405",
    "data-name": "Pfad 15405",
    d: "M1967.156,2058.188l7.13-2.812h-30.638v2.812Z",
    transform: "translate(-1943.648 -2055.376)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4150",
    "data-name": "Gruppe 4150",
    transform: "translate(0 71.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15406",
    "data-name": "Pfad 15406",
    d: "M1943.648,2065.884v2.513l6.372-2.513Z",
    transform: "translate(-1943.648 -2065.884)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4151",
    "data-name": "Gruppe 4151",
    transform: "translate(0 28.709)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1788",
    "data-name": "Rechteck 1788",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4152",
    "data-name": "Gruppe 4152",
    transform: "translate(0 57.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15407",
    "data-name": "Pfad 15407",
    d: "M1943.648,2050.123v2.812h35.642l7.13-2.812Z",
    transform: "translate(-1943.648 -2050.123)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4153",
    "data-name": "Gruppe 4153",
    transform: "translate(91.285 71.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15408",
    "data-name": "Pfad 15408",
    d: "M2043.876,2065.884l6.371,2.513v-2.513Z",
    transform: "translate(-2043.876 -2065.884)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4154",
    "data-name": "Gruppe 4154",
    transform: "translate(0 66.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15409",
    "data-name": "Pfad 15409",
    d: "M1955.023,2063.442l7.13-2.812h-18.5v2.812Z",
    transform: "translate(-1943.648 -2060.63)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4155",
    "data-name": "Gruppe 4155",
    transform: "translate(79.152 66.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15410",
    "data-name": "Pfad 15410",
    d: "M2030.554,2060.63l7.13,2.812h11.375v-2.812Z",
    transform: "translate(-2030.554 -2060.63)",
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4156",
    "data-name": "Gruppe 4156",
    transform: "translate(0 23.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1789",
    "data-name": "Rechteck 1789",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4157",
    "data-name": "Gruppe 4157",
    transform: "translate(0 14.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1790",
    "data-name": "Rechteck 1790",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4158",
    "data-name": "Gruppe 4158",
    transform: "translate(0 9.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1791",
    "data-name": "Rechteck 1791",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4159",
    "data-name": "Gruppe 4159",
    transform: "translate(0 19.139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1792",
    "data-name": "Rechteck 1792",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4160",
    "data-name": "Gruppe 4160",
    transform: "translate(0 4.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1793",
    "data-name": "Rechteck 1793",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4161",
    "data-name": "Gruppe 4161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1794",
    "data-name": "Rechteck 1794",
    width: 97.656,
    height: 2.812,
    fill: "#f5f7f6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4163",
    "data-name": "Gruppe 4163",
    transform: "translate(3.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15411",
    "data-name": "Pfad 15411",
    d: "M2041.217,2057.209a.89.89,0,0,1-.324-.061l-48.5-19.127-48.5,19.127a.884.884,0,0,1-1.208-.823V1931.474a.884.884,0,0,1,.883-.884h19.516a.884.884,0,1,1,0,1.769h-18.632v122.668l47.62-18.778a.885.885,0,0,1,.649,0l47.62,18.778V1932.358H2021.7a.884.884,0,0,1,0-1.769h19.516a.885.885,0,0,1,.884.884v124.852a.885.885,0,0,1-.884.884Z",
    transform: "translate(-1942.677 -1930.589)",
    fill: "#d2dad7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4179",
    "data-name": "Gruppe 4179",
    transform: "translate(7.971 90.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4168",
    "data-name": "Gruppe 4168",
    transform: "translate(24.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4165",
    "data-name": "Gruppe 4165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4164",
    "data-name": "Gruppe 4164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15412",
    "data-name": "Pfad 15412",
    d: "M2001.7,2043.84l-6.671-14.192-6.429,14.192-14.313,1.82,10.189,10.31-2.184,14.192,12.736-6.55,12.857,6.55-2.183-14.192,10.432-10.31Z",
    transform: "translate(-1974.286 -2029.648)",
    fill: "#44554c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4167",
    "data-name": "Gruppe 4167",
    transform: "translate(5.682 6.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4166",
    "data-name": "Gruppe 4166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15413",
    "data-name": "Pfad 15413",
    d: "M2004.7,2066.452a.491.491,0,0,1-.224-.055l-8.837-4.5-8.753,4.5a.492.492,0,0,1-.712-.513l1.5-9.759-7.007-7.091a.493.493,0,0,1,.289-.836l9.815-1.248,4.417-9.753a.5.5,0,0,1,.446-.291h0a.492.492,0,0,1,.446.284l4.587,9.758,9.906,1.249a.493.493,0,0,1,.285.84l-7.174,7.09,1.5,9.755a.494.494,0,0,1-.487.568Zm-9.062-5.6a.491.491,0,0,1,.224.055l8.2,4.18-1.392-9.052a.49.49,0,0,1,.14-.424l6.631-6.555-9.168-1.156a.492.492,0,0,1-.385-.28l-4.247-9.036-4.09,9.03a.494.494,0,0,1-.387.286l-9.1,1.157,6.479,6.557a.49.49,0,0,1,.137.422l-1.392,9.048,8.118-4.174A.5.5,0,0,1,1995.638,2060.847Z",
    transform: "translate(-1980.525 -2036.907)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4173",
    "data-name": "Gruppe 4173",
    transform: "translate(0 0.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4170",
    "data-name": "Gruppe 4170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4169",
    "data-name": "Gruppe 4169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15414",
    "data-name": "Pfad 15414",
    d: "M1962.91,2038.22l-3.773-8.026-3.635,8.026-8.094,1.029,5.762,5.831-1.235,8.026,7.2-3.7,7.271,3.7-1.234-8.026,5.9-5.831Z",
    transform: "translate(-1947.407 -2030.195)",
    fill: "#44554c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4172",
    "data-name": "Gruppe 4172",
    transform: "translate(3.48 3.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4171",
    "data-name": "Gruppe 4171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15415",
    "data-name": "Pfad 15415",
    d: "M1954.729,2050.62a.494.494,0,0,1-.487-.568l.782-5.086-3.653-3.7a.493.493,0,0,1,.289-.836l5.1-.648,2.3-5.08a.494.494,0,0,1,.445-.29.449.449,0,0,1,.45.284l2.39,5.085,5.153.649a.493.493,0,0,1,.285.84l-3.74,3.7.782,5.082a.493.493,0,0,1-.711.514l-4.6-2.344-4.559,2.343A.48.48,0,0,1,1954.729,2050.62Zm4.783-3.446a.485.485,0,0,1,.224.054l3.971,2.023-.673-4.379a.5.5,0,0,1,.14-.425l3.2-3.159-4.415-.557a.492.492,0,0,1-.384-.28l-2.051-4.363-1.974,4.356a.493.493,0,0,1-.387.286l-4.385.557,3.125,3.162a.49.49,0,0,1,.137.422l-.672,4.374,3.924-2.017A.49.49,0,0,1,1959.512,2047.174Z",
    transform: "translate(-1951.229 -2034.411)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4178",
    "data-name": "Gruppe 4178",
    transform: "translate(67.142 0.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4175",
    "data-name": "Gruppe 4175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4174",
    "data-name": "Gruppe 4174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15416",
    "data-name": "Pfad 15416",
    d: "M2036.63,2038.22l-3.773-8.026-3.635,8.026-8.095,1.029,5.762,5.831-1.235,8.026,7.2-3.7,7.271,3.7-1.234-8.026,5.9-5.831Z",
    transform: "translate(-2021.127 -2030.195)",
    fill: "#44554c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4177",
    "data-name": "Gruppe 4177",
    transform: "translate(3.48 3.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4176",
    "data-name": "Gruppe 4176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15417",
    "data-name": "Pfad 15417",
    d: "M2028.449,2050.621a.495.495,0,0,1-.487-.568l.781-5.086-3.652-3.7a.494.494,0,0,1,.289-.836l5.1-.648,2.3-5.08a.494.494,0,0,1,.445-.29h0a.493.493,0,0,1,.446.284l2.39,5.085,5.151.649a.493.493,0,0,1,.286.84l-3.74,3.7.782,5.082a.493.493,0,0,1-.711.514l-4.6-2.344-4.559,2.344A.484.484,0,0,1,2028.449,2050.621Zm4.784-3.446a.489.489,0,0,1,.224.054l3.97,2.023-.673-4.379a.5.5,0,0,1,.14-.425l3.2-3.159-4.413-.557a.492.492,0,0,1-.385-.28l-2.051-4.363-1.974,4.356a.494.494,0,0,1-.387.286l-4.386.557,3.126,3.162a.5.5,0,0,1,.137.422l-.673,4.375,3.924-2.018A.5.5,0,0,1,2033.233,2047.174Z",
    transform: "translate(-2024.949 -2034.417)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4182",
    "data-name": "Gruppe 4182",
    transform: "translate(0 21.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4180",
    "data-name": "Gruppe 4180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15418",
    "data-name": "Pfad 15418",
    d: "M1949.417,1967.866h-10.761v-13.881h10.761l-3.947,6.94Z",
    transform: "translate(-1938.655 -1953.985)",
    fill: "#44554c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4181",
    "data-name": "Gruppe 4181",
    transform: "translate(95.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15419",
    "data-name": "Pfad 15419",
    d: "M2044.048,1953.985h10.711v13.881h-10.711l3.946-6.94Z",
    transform: "translate(-2044.048 -1953.985)",
    fill: "#44554c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4188",
    "data-name": "Gruppe 4188",
    transform: "translate(20.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4185",
    "data-name": "Gruppe 4185",
    transform: "translate(0 19.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4184",
    "data-name": "Gruppe 4184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15420",
    "data-name": "Pfad 15420",
    d: "M1964.352,1969.557a6.031,6.031,0,0,1-2.575-2.02,5.035,5.035,0,0,1-.938-2.748.542.542,0,0,1,.555-.554h3.539a.856.856,0,0,1,.845.5,2.641,2.641,0,0,0,2.668,1.769,2.833,2.833,0,0,0,1.968-.726,2.582,2.582,0,0,0,.805-2.02,2.505,2.505,0,0,0-.779-1.9,2.781,2.781,0,0,0-1.995-.74,2.891,2.891,0,0,0-1.1.172,3.9,3.9,0,0,0-.833.489,1.348,1.348,0,0,1-.712.344h-3.461a.588.588,0,0,1-.581-.581l.951-9.218a.8.8,0,0,1,.278-.582.894.894,0,0,1,.594-.21h10.591a.687.687,0,0,1,.489.185.619.619,0,0,1,.2.474v2.484a.617.617,0,0,1-.2.474.688.688,0,0,1-.489.186h-7.66l-.343,3.407a4.982,4.982,0,0,1,1.453-.674,7.775,7.775,0,0,1,2.06-.225,6.838,6.838,0,0,1,3.143.753,6,6,0,0,1,2.364,2.127,5.673,5.673,0,0,1,.884,3.143,5.99,5.99,0,0,1-3.578,5.625,9.461,9.461,0,0,1-4.081.82A9.941,9.941,0,0,1,1964.352,1969.557Z",
    transform: "translate(-1968.839 -1951.294)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15421",
    "data-name": "Pfad 15421",
    d: "M1981.506,1968.316a7.448,7.448,0,0,1-2.033-5.032q-.055-1.426-.054-2.536,0-1.135.054-2.615a8.032,8.032,0,0,1,.964-3.526,6.217,6.217,0,0,1,2.523-2.456,8.36,8.36,0,0,1,4.067-.911,7.572,7.572,0,0,1,5.494,1.928,7.216,7.216,0,0,1,2.087,4.965q.053,1.479.053,2.615,0,1.111-.053,2.536a7.56,7.56,0,0,1-2.059,5.032,8.819,8.819,0,0,1-11.041,0Zm7.462-2.747a4.2,4.2,0,0,0,.7-2.416q.053-.766.053-2.456t-.053-2.4a4.227,4.227,0,0,0-.687-2.377,2.559,2.559,0,0,0-3.9,0,4.15,4.15,0,0,0-.7,2.377q-.027.712-.027,2.4t.027,2.456q.131,3.275,2.64,3.275A2.279,2.279,0,0,0,1988.968,1965.569Z",
    transform: "translate(-1955.499 -1951.241)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15422",
    "data-name": "Pfad 15422",
    d: "M2000.385,1968.316a7.454,7.454,0,0,1-2.034-5.032q-.053-1.426-.053-2.536,0-1.135.053-2.615a8.044,8.044,0,0,1,.965-3.526,6.217,6.217,0,0,1,2.523-2.456,8.361,8.361,0,0,1,4.067-.911,7.572,7.572,0,0,1,5.494,1.928,7.22,7.22,0,0,1,2.087,4.965q.053,1.479.053,2.615,0,1.111-.053,2.536a7.555,7.555,0,0,1-2.06,5.032,8.817,8.817,0,0,1-11.04,0Zm7.461-2.747a4.19,4.19,0,0,0,.7-2.416q.053-.766.053-2.456t-.053-2.4a4.227,4.227,0,0,0-.687-2.377,2.559,2.559,0,0,0-3.9,0,4.157,4.157,0,0,0-.7,2.377q-.027.712-.026,2.4t.026,2.456q.133,3.275,2.641,3.275A2.277,2.277,0,0,0,2007.846,1965.569Z",
    transform: "translate(-1958.182 -1951.241)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15423",
    "data-name": "Pfad 15423",
    d: "M2019.264,1968.316a7.453,7.453,0,0,1-2.034-5.032q-.053-1.426-.053-2.536,0-1.135.053-2.615a8.044,8.044,0,0,1,.964-3.526,6.221,6.221,0,0,1,2.522-2.456,8.367,8.367,0,0,1,4.068-.911,7.574,7.574,0,0,1,5.494,1.928,7.22,7.22,0,0,1,2.087,4.965q.053,1.479.053,2.615,0,1.111-.053,2.536a7.555,7.555,0,0,1-2.06,5.032,8.817,8.817,0,0,1-11.04,0Zm7.461-2.747a4.189,4.189,0,0,0,.7-2.416q.053-.766.053-2.456t-.053-2.4a4.225,4.225,0,0,0-.687-2.377,2.56,2.56,0,0,0-3.9,0,4.161,4.161,0,0,0-.7,2.377q-.027.712-.026,2.4t.026,2.456q.132,3.275,2.641,3.275A2.277,2.277,0,0,0,2026.725,1965.569Z",
    transform: "translate(-1960.866 -1951.241)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47052",
    "data-name": "Pfad 47052",
    d: "M1981.506,1968.316a7.448,7.448,0,0,1-2.033-5.032q-.055-1.426-.054-2.536,0-1.135.054-2.615a8.032,8.032,0,0,1,.964-3.526,6.217,6.217,0,0,1,2.523-2.456,8.36,8.36,0,0,1,4.067-.911,7.572,7.572,0,0,1,5.494,1.928,7.216,7.216,0,0,1,2.087,4.965q.053,1.479.053,2.615,0,1.111-.053,2.536a7.56,7.56,0,0,1-2.059,5.032,8.819,8.819,0,0,1-11.041,0Zm7.462-2.747a4.2,4.2,0,0,0,.7-2.416q.053-.766.053-2.456t-.053-2.4a4.227,4.227,0,0,0-.687-2.377,2.559,2.559,0,0,0-3.9,0,4.15,4.15,0,0,0-.7,2.377q-.027.712-.027,2.4t.027,2.456q.131,3.275,2.64,3.275A2.279,2.279,0,0,0,1988.968,1965.569Z",
    transform: "translate(-1971.693 -1951.241)",
    fill: "#44554c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4187",
    "data-name": "Gruppe 4187",
    transform: "translate(11.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4186",
    "data-name": "Gruppe 4186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15424",
    "data-name": "Pfad 15424",
    d: "M1973.642,1935.769a.2.2,0,0,1-.059-.15v-5.947a.216.216,0,0,1,.059-.159.2.2,0,0,1,.15-.059h.455a.27.27,0,0,1,.237.146l1.923,3.68,1.939-3.68a.227.227,0,0,1,.077-.1.244.244,0,0,1,.15-.045h.446a.216.216,0,0,1,.16.059.219.219,0,0,1,.058.159v5.947a.192.192,0,0,1-.064.15.216.216,0,0,1-.155.06h-.446a.2.2,0,0,1-.209-.21v-4.481l-1.52,2.97a.3.3,0,0,1-.292.191h-.282a.3.3,0,0,1-.291-.191l-1.53-2.97v4.481a.2.2,0,0,1-.209.21h-.446A.2.2,0,0,1,1973.642,1935.769Z",
    transform: "translate(-1973.583 -1929.363)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15425",
    "data-name": "Pfad 15425",
    d: "M1981.591,1935.769a.2.2,0,0,1-.059-.15v-5.947a.216.216,0,0,1,.059-.159.2.2,0,0,1,.15-.059h3.761a.2.2,0,0,1,.15.059.213.213,0,0,1,.059.159v.346a.213.213,0,0,1-.055.15.2.2,0,0,1-.155.058h-3.1v2h2.9a.2.2,0,0,1,.15.059.216.216,0,0,1,.059.159v.337a.2.2,0,0,1-.209.209h-2.9v2.068h3.17a.19.19,0,0,1,.209.209v.355a.2.2,0,0,1-.209.21h-3.834A.2.2,0,0,1,1981.591,1935.769Z",
    transform: "translate(-1974.292 -1929.363)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15426",
    "data-name": "Pfad 15426",
    d: "M1987.651,1935.769a.2.2,0,0,1-.059-.15v-5.947a.216.216,0,0,1,.059-.159.2.2,0,0,1,.15-.059h.464a.212.212,0,0,1,.159.059.216.216,0,0,1,.059.159v2.514h3.133v-2.514a.216.216,0,0,1,.059-.159.2.2,0,0,1,.15-.059h.464a.212.212,0,0,1,.16.059.216.216,0,0,1,.059.159v5.947a.192.192,0,0,1-.064.15.217.217,0,0,1-.155.06h-.464a.2.2,0,0,1-.209-.21v-2.613h-3.133v2.613a.192.192,0,0,1-.064.15.215.215,0,0,1-.155.06h-.464A.2.2,0,0,1,1987.651,1935.769Z",
    transform: "translate(-1974.833 -1929.363)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15427",
    "data-name": "Pfad 15427",
    d: "M1994.8,1935.769a.2.2,0,0,1-.059-.15v-5.947a.216.216,0,0,1,.059-.159.2.2,0,0,1,.15-.059h2.222a2.485,2.485,0,0,1,1.639.492,1.739,1.739,0,0,1,.592,1.42,1.817,1.817,0,0,1-.342,1.138,1.766,1.766,0,0,1-.961.62l1.4,2.423a.225.225,0,0,1,.027.1.171.171,0,0,1-.059.128.191.191,0,0,1-.132.055h-.437a.327.327,0,0,1-.214-.065.614.614,0,0,1-.141-.181l-1.321-2.313h-1.594v2.349a.192.192,0,0,1-.064.15.217.217,0,0,1-.155.06h-.464A.2.2,0,0,1,1994.8,1935.769Zm2.336-3.274q1.357,0,1.357-1.139t-1.357-1.138h-1.5v2.277Z",
    transform: "translate(-1975.471 -1929.363)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15428",
    "data-name": "Pfad 15428",
    d: "M2003.126,1935.775a.176.176,0,0,1-.055-.128.355.355,0,0,1,.009-.1l2.259-5.894a.283.283,0,0,1,.291-.2h.619a.284.284,0,0,1,.291.2l2.25,5.894.018.1a.177.177,0,0,1-.055.128.175.175,0,0,1-.128.055h-.464a.224.224,0,0,1-.155-.05.252.252,0,0,1-.073-.1l-.5-1.293h-2.987l-.5,1.293a.243.243,0,0,1-.077.1.228.228,0,0,1-.15.05h-.464A.176.176,0,0,1,2003.126,1935.775Zm4.044-2.178-1.23-3.232-1.229,3.232Z",
    transform: "translate(-1976.214 -1929.363)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15429",
    "data-name": "Pfad 15429",
    d: "M2010.659,1935.769a.2.2,0,0,1-.059-.15v-5.956a.2.2,0,0,1,.209-.209h.482a.2.2,0,0,1,.21.209v5.373h3.024a.2.2,0,0,1,.218.219v.364a.2.2,0,0,1-.063.15.217.217,0,0,1-.155.06h-3.716A.2.2,0,0,1,2010.659,1935.769Z",
    transform: "translate(-1976.886 -1929.363)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15430",
    "data-name": "Pfad 15430",
    d: "M2017.158,1935.674a2.013,2.013,0,0,1-.841-.623,1.457,1.457,0,0,1-.31-.833.185.185,0,0,1,.058-.133.2.2,0,0,1,.142-.058h.464a.238.238,0,0,1,.238.182,1.082,1.082,0,0,0,.469.656,1.865,1.865,0,0,0,1.089.273,1.989,1.989,0,0,0,1.138-.269.87.87,0,0,0,.382-.752.682.682,0,0,0-.187-.5,1.584,1.584,0,0,0-.552-.337q-.363-.146-1.093-.365a5.57,5.57,0,0,1-1.128-.428,1.625,1.625,0,0,1-.628-.565,1.569,1.569,0,0,1-.209-.846,1.52,1.52,0,0,1,.269-.883,1.78,1.78,0,0,1,.77-.616,2.917,2.917,0,0,1,1.192-.222,2.763,2.763,0,0,1,1.221.25,1.972,1.972,0,0,1,.774.634,1.456,1.456,0,0,1,.281.765.179.179,0,0,1-.049.127.183.183,0,0,1-.142.056h-.482a.22.22,0,0,1-.238-.174.9.9,0,0,0-.427-.632,1.648,1.648,0,0,0-.939-.25,1.748,1.748,0,0,0-.974.236.791.791,0,0,0-.356.7.761.761,0,0,0,.169.509,1.36,1.36,0,0,0,.514.351,8.508,8.508,0,0,0,1.012.342,6.889,6.889,0,0,1,1.219.434,1.649,1.649,0,0,1,.666.555,1.507,1.507,0,0,1,.218.843,1.559,1.559,0,0,1-.656,1.33,2.916,2.916,0,0,1-1.766.482A3.29,3.29,0,0,1,2017.158,1935.674Z",
    transform: "translate(-1977.368 -1929.354)",
    fill: "#44554c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4190",
    "data-name": "Gruppe 4190",
    transform: "translate(0 64.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15431",
    "data-name": "Pfad 15431",
    d: "M2070.47,2011.68H1915.029l5.741-10.211-5.741-10.211H2070.47l-5.741,10.211Z",
    transform: "translate(-1915.029 -1991.258)",
    fill: "#d2dad7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4191",
    "data-name": "Gruppe 4191",
    transform: "translate(1.8 56.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15432",
    "data-name": "Pfad 15432",
    d: "M2068.847,2018.3H1917l9.866-17.549L1917,1983.2h151.843l-9.867,17.549Z",
    transform: "translate(-1917.005 -1983.201)",
    fill: "#44554c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15433",
    "data-name": "Pfad 15433",
    d: "M-64.878-1.062a.323.323,0,0,1-.225-.093.3.3,0,0,1-.1-.232l.031-.139,3.731-9.987A.5.5,0,0,1-60.9-11.9h1.688a.532.532,0,0,1,.542.387l3.731,9.987a.47.47,0,0,1,.015.139.315.315,0,0,1-.093.232.3.3,0,0,1-.217.093h-1.347a.462.462,0,0,1-.31-.093.421.421,0,0,1-.139-.2l-.728-1.889h-4.6l-.728,1.889a.449.449,0,0,1-.449.294Zm6.58-3.964L-60.063-9.81l-1.75,4.784Zm5.187,3.964a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-10.08a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h1.363a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279V-7.89l3.5-3.731a.7.7,0,0,1,.6-.279h1.533a.323.323,0,0,1,.225.093.3.3,0,0,1,.1.232.288.288,0,0,1-.062.186L-49.72-6.713l4.552,5.125a.308.308,0,0,1,.077.2.3.3,0,0,1-.1.232.323.323,0,0,1-.225.093h-1.595a.722.722,0,0,1-.6-.279l-3.747-4.1v4.01a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1Zm12.17,0A.358.358,0,0,1-41.2-1.17a.358.358,0,0,1-.108-.263V-10h-2.864a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-1.146a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h7.9a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.146A.358.358,0,0,1-36-10.1a.377.377,0,0,1-.279.108H-39.13v8.562a.358.358,0,0,1-.108.263.377.377,0,0,1-.279.108Zm6.983,0a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-10.1a.352.352,0,0,1,.108-.271.373.373,0,0,1,.263-.1H-32.5a.366.366,0,0,1,.271.1.366.366,0,0,1,.1.271v10.1a.373.373,0,0,1-.1.263.352.352,0,0,1-.271.108Zm7.416,0A.568.568,0,0,1-27.13-1.5l-3.313-9.94-.031-.139a.315.315,0,0,1,.093-.232.315.315,0,0,1,.232-.093h1.363a.468.468,0,0,1,.317.1.539.539,0,0,1,.163.24l2.617,7.974,2.617-7.974a.462.462,0,0,1,.155-.232.476.476,0,0,1,.325-.108h1.363a.323.323,0,0,1,.225.093.3.3,0,0,1,.1.232l-.031.139L-24.251-1.5a.568.568,0,0,1-.588.434Zm7.649,0a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-10.08a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h6.813a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.022a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1h-5.094v2.741h4.753a.393.393,0,0,1,.279.1.352.352,0,0,1,.108.271v.96a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1h-4.753v2.833h5.218a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.022a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1Zm13.176,0A.358.358,0,0,1-5.98-1.17a.358.358,0,0,1-.108-.263v-10.08a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h1.192a.462.462,0,0,1,.279.07.8.8,0,0,1,.17.178L.383-4.716v-6.8a.393.393,0,0,1,.1-.279A.352.352,0,0,1,.755-11.9h1.3a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279V-1.449a.377.377,0,0,1-.108.279.358.358,0,0,1-.263.108H.863A.548.548,0,0,1,.414-1.31L-4.03-8.091v6.658a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1ZM9.177-.907A4.624,4.624,0,0,1,5.926-1.975,4.187,4.187,0,0,1,4.765-5.211v-6.3a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108H6.545a.352.352,0,0,1,.271.108.393.393,0,0,1,.1.279v6.3a2.636,2.636,0,0,0,.588,1.866,2.181,2.181,0,0,0,1.672.627,2.156,2.156,0,0,0,1.664-.627,2.659,2.659,0,0,0,.581-1.866v-6.3a.377.377,0,0,1,.108-.279.377.377,0,0,1,.279-.108H13.2a.352.352,0,0,1,.271.108.393.393,0,0,1,.1.279v6.3a4.2,4.2,0,0,1-1.153,3.236A4.6,4.6,0,0,1,9.177-.907Zm9.476-.155a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263V-10H15.417a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-1.146a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h7.9a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.146a.358.358,0,0,1-.108.263.377.377,0,0,1-.279.108H20.465v8.562a.358.358,0,0,1-.108.263.377.377,0,0,1-.279.108Zm6.379,0a.352.352,0,0,1-.271-.108.393.393,0,0,1-.1-.279V-2.533a.68.68,0,0,1,.108-.41q.108-.147.124-.163l5.388-6.967H25.187a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-1.068a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h7.4a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.068a.883.883,0,0,1-.2.542l-5.28,7h5.264a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.084a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1Zm10.281,0a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-10.08a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h6.813a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.022a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1H37.032v2.741h4.753a.393.393,0,0,1,.279.1.352.352,0,0,1,.108.271v.96a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1H37.032v2.833h5.218a.377.377,0,0,1,.279.108.377.377,0,0,1,.108.279v1.022a.352.352,0,0,1-.108.271.393.393,0,0,1-.279.1Zm9.631,0a.358.358,0,0,1-.263-.108.358.358,0,0,1-.108-.263v-10.08a.393.393,0,0,1,.1-.279.352.352,0,0,1,.271-.108h4.01a4.544,4.544,0,0,1,2.965.883,3.06,3.06,0,0,1,1.076,2.508,3.17,3.17,0,0,1-.55,1.9A3.058,3.058,0,0,1,50.92-5.505l2.261,3.948a.385.385,0,0,1,.046.17.3.3,0,0,1-.1.232.323.323,0,0,1-.225.093H51.493a.583.583,0,0,1-.379-.108,1.023,1.023,0,0,1-.24-.31l-2-3.67H46.724v3.716a.373.373,0,0,1-.1.263.352.352,0,0,1-.271.108ZM48.907-6.9a2.057,2.057,0,0,0,1.4-.418,1.528,1.528,0,0,0,.472-1.208,1.577,1.577,0,0,0-.472-1.223,2.007,2.007,0,0,0-1.4-.434H46.724V-6.9Z",
    transform: "translate(83.369 80.785)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg50KNutzer);
export default __webpack_public_path__ + "static/media/50k-nutzer.d283d141b863ae6494d18815ab8fad32.svg";
export { ForwardRef as ReactComponent };